








































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import { BIcon, BIconBoxArrowRight, BPopover } from "bootstrap-vue";
import Footer from "@/components/Footer.vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import { hasProto } from "vue-class-component/lib/util";
@Component({
  components: {
    Header,
    Menu,
    BIconBoxArrowRight,
    BIcon,
    BPopover,
    NextPrevBtn,
    Footer,
  },
})
export default class AudioVisualEditing extends Vue {
  protected nxtprevAudioVisualEditing = {
    BoolPrev: true,
    BoolNext: false ,
    PrevImage: "/thumbnail3.png",
    NextImage: "",
    PrevLink: "/Audiovisuel/Fondamentaux",
    NextLink: "",
  };
}
